<template>
  <div class="w-full sm:w-156 2xl:w-239 flex flex-col-reverse sm:flex-row items-start justify-between mb-6">
    <div class="w-full sm:w-156 2xl:w-239 flex flex-wrap items-center justify-start">
      <FeedFilterTagFulltext
        v-if="filters.fulltext"
        :data="filters.fulltext"
        type="fulltext"
      />
      <FeedFilterTagSupplier
        v-if="filters.idSupplier"
        :data="filters.idSupplier"
        type="idSupplier"
      />
      <FeedFilterTagCategory
        v-if="filters.idCategory"
        :data="filters.idCategory"
        :type="type"
      />
      <FeedFilterTagCategory
        v-else-if="filters.idPostCategory"
        :data="filters.idPostCategory"
        :type="type"
      />
      <FeedFilterTagLocation
        v-if="filters.location && (type === CATEGORY_TYPE.ESHOP)"
        :data="filters.location"
        type="location"
      />
      <FeedFilterTagLocation
        v-if="filters.maxKmFromHome && (type === CATEGORY_TYPE.ESHOP)"
        :data="filters.maxKmFromHome"
        type="maxKmFromHome"
      />
      <FeedFilterTagLocation
        v-if="filters.maxKmFromLocation && (type === CATEGORY_TYPE.ESHOP)"
        :data="filters.maxKmFromLocation"
        type="maxKmFromLocation"
      />
      <FeedFilterTagParameter
        v-for="item in filters.eshopParameters"
        :key="`${type}_${item.idParameter}_${item.idValue}`"
        :data="item"
        :type="type"
      />
      <FeedContentTagParameter
        v-for="item in filters.contentParameters"
        :key="`${type}_${item.idParameter}_${item.idValue}`"
        :data="item"
        :type="type"
      />
      <FeedClearFilters
        v-if="filters.idCategory || filters.idPostCategory || filters.location || filters.maxKmFromHome || filters.maxKmFromLocation || filters.eshopParameters?.length || filters.contentParameters?.length"
      />
    </div>
    <div class="mb-2 w-full sm:w-fit flex justify-end">
      <FeedSortbyPicker :type="type" :is-detail="isDetail" />
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { CATEGORY_TYPE } from "@utils/constants";
import FeedFilterTagFulltext from "@components/filter/feed/feed-filter-tag-fulltext";
import FeedFilterTagSupplier from "@components/filter/feed/feed-filter-tag-supplier";
import FeedFilterTagCategory from "@components/filter/feed/feed-filter-tag-category";
import FeedFilterTagLocation from "@components/filter/feed/feed-filter-tag-location";
import FeedFilterTagParameter from "@components/filter/feed/feed-filter-tag-parameter";
import FeedContentTagParameter from "@components/filter/feed/feed-content-tag-parameter";
import FeedClearFilters from "@components/filter/feed/feed-clear-filters";
import FeedSortbyPicker from "@components/filter/feed/feed-sortby-picker";

defineProps({
  type: {
    type: String,
    default: 'eshop'
  },
  isDetail: {
    type: Boolean,
    default: false
  }
});

const route = useRoute();

const routeName = computed(() => route?.name || '');

const transformTagParameters = (regex, values) => {
  return _.chain(values)
    .cloneDeep()
    .transform((result, value, key) => {
      if (regex.test(key)) {
        const idParameter = parseInt(_.get(key.match(regex), '1', null));
        result.parameters = _.get(result, 'parameters', []);
        result.parameters.push(..._.chain(value).split(',').map(
          v => _.isString(v) && !isNaN(v) ? { idParameter, idValue: parseInt(v) } : { idParameter, idValue: v }
        ).value());
      } else {
        result[key] = null;
      }
    })
    .omitBy(_.isNull)
    .value()?.parameters || null;
}

const filters = ref({
  idSupplier: +(route.query.idSupplier || null),
  idCategory: +(route.query.idCategory || (routeName.value.startsWith('category-slug___') ? parseInt(route.params?.slug) : null)),
  idPostCategory: +(route.query.idPostCategory || (routeName.value.startsWith('inspiration-type-slug___') || routeName.value.startsWith('news-about-slug___') ? parseInt(route.params?.slug) : null)),
  fulltext: route.query?.fulltext || null,
  location: route.query?.location || null,
  maxKmFromHome: route.query?.maxKmFromHome ? +route.query?.maxKmFromHome : null,
  maxKmFromLocation: route.query?.maxKmFromLocation ? +route.query?.maxKmFromLocation : null,
  eshopParameters: transformTagParameters(/^p\[(\d+)\]$/, route.query),
  contentParameters: transformTagParameters(/^t\[(\d+)\]$/, route.query),
});

watch(() => route.query, (query) => {
  filters.value.idSupplier = _.get(query, 'idSupplier', null);
  filters.value.idCategory = _.get(query, 'idCategory', null);
  filters.value.idPostCategory = _.get(query, 'idPostCategory', null);
  filters.value.fulltext = _.get(query, 'fulltext', null);
  filters.value.location = _.get(query, 'location', null);
  filters.value.maxKmFromHome = query?.maxKmFromHome ? +query?.maxKmFromHome : null;
  filters.value.maxKmFromLocation = query?.maxKmFromLocation ? +query?.maxKmFromLocation : null;
  filters.value.eshopParameters = transformTagParameters(/^p\[(\d+)\]$/, query);
  filters.value.contentParameters = transformTagParameters(/^t\[(\d+)\]$/, query);
});

</script>
